import 'es6-promise/auto'

import Vue from 'vue'
import Vuex from 'vuex'
import api from '@/services/api'
import verifica_token_storage from '@/utils/verifica_token_storage'


Vue.use(Vuex)


const store = new Vuex.Store({
    state:{
        date_state: new Date().toISOString().substr(0, 7),
        entrada: [],
        saida: [],
        valores: {},
        response_cadastro: null,
        carregando: false,
        status_entrada: [],
        status_saida: [],
    },

    getters: {
        getResponseCadastro(self) {
            return self.response_cadastro;
        },

        getDateState(self) {
            return self.date_state;
        },

        getItemsSaida(self) {
            return self.saida;
        },

        getItemsEntrada(self) {
            return self.entrada;
        },

        getValores(self) {
            return self.valores;
        },

        getCarregando(self) {
            return self.carregando;
        },

        getStatusEntrada(self) {
            return self.status_entrada;
        },

        getStatusSaida(self){
            return self.status_saida;
        },
    },

    actions: {
        dividasAnoMesAction({ commit }, anoMes) {
            this.state.carregando=true;
            const headers = verifica_token_storage();

            api.get('parcelas/' + anoMes, {headers})
            .then(( response ) => {
                commit('atualizarEntradaSaidaMutation', response.data)
            })
            .catch((error) => {
                console.log(error);
            })
            .finally(() => {
                this.state.carregando=false;
            })
        },

        adicionarAction({ commit }, form) {
            this.state.carregando=true;
            const headers = verifica_token_storage();

            api.post('dividas/', form, {headers})
            .then((response) => {
                commit('adicionarMutation', response.data.data[0])
            })
            .catch((error) => {
                console.log(error);
            })
            .finally(() => {
                this.state.carregando=false;
            })
        },

        atualizarAction({ commit }, form) {
            this.state.carregando=true;
            const headers = verifica_token_storage();

            api.put('dividas/', form, {headers})
            .then((response) => {
                commit('atualizarEntradaSaidaMutation', response.data)
            })
            .catch((error) => {
                console.log(error);
            })
            .finally(() => {
                this.state.carregando=false;
            })
        },

        getStatusParcelaAction({ commit }, tipo) {
            this.state.carregando=true;
            const headers = verifica_token_storage();

            api.get(`parcelas/status/${tipo}`, {headers})
            .then((response) => {
                commit('getStatusParcelaMutation', response.data)
            })
            .catch((error) => {
                console.log(error);
            })
            .finally(() => {
                this.state.carregando=false;
            })
        },

        atualizarStatusParcelaAction({ commit }, item) {
            const data = {'id_parcela': item.id, 'nome_status': item.status_pago.nome}
            this.state.carregando=true;
            const headers = verifica_token_storage();

            api.put('parcelas/status/',data, {headers})
            .then((response) => {
                commit('atualizarEntradaSaidaMutation', response.data)
            })
            .catch((error) => {
                console.log(error);
            })
            .finally(() => {
                this.state.carregando=false;
            })
        },

        removerAction({ commit }, item) {
            this.state.carregando=true;
            const headers = verifica_token_storage();

            api.delete('dividas/' + item.divida.id, {headers})
            .then(() => {
                commit('removerMutation', item.id)
            })
            .catch((error) => {
                console.log(error);
            })
            .finally(() => {
                this.state.carregando=false;
            })
        },

        painelValoresAction({ commit }, date) {
            this.state.carregando=true;
            const headers = verifica_token_storage();

            api.get('painel-valores/' + date, {headers})
            .then((response) => {
                commit('painelValoresMutation', response.data)
            })
            .catch((error) => {
                console.log(error);
            })
            .finally(() => {
                this.state.carregando=false;
            })
        },

        AuthLoginAction({ commit }, form) {
            this.state.carregando=true

            return api.post('token/', form)
                    .then((response) => {
                        commit('AuthLoginMutation', response.data)
                    })
                    .catch((error) => {
                        console.log(error);
                    })
                    .finally(() => {
                        this.state.carregando=false
                    })
        },

        AuthCadastroAction({ commit }, form) {
            this.state.carregando=true

            return api.post('auth/cadastro/', form)
                    .then((response) => {
                        commit('AuthCadastroMutation', response.data)
                    })
                    .catch((error) => {
                        console.log(error);
                    })
                    .finally(() => {
                        this.state.carregando=false
                    })
        }
    },

    mutations: {
        atualizarEntradaSaidaMutation(state, data) {
            state.entrada = data.data.entrada;
            state.saida = data.data.saida;
        },

        adicionarMutation(state, data) {
            const mes = state.date_state.slice(5,7)
            const ano = state.date_state.slice(0, 4)
            const data_referencia = '01/'+mes+'/'+ano

            if (data_referencia === data['data']) {
                if (data['divida']['tipo'] === 'entrada') {
                        state.entrada.push(data)
                } else {
                        state.saida.push(data)
                }
            }
        },

        removerMutation(state, id_parcela) {
            if (state.entrada.find(elemento => elemento.id === id_parcela)) {
                state.entrada = state.entrada.filter(item => item.id != id_parcela)
            }else {
                state.saida = state.saida.filter(item => item.id != id_parcela)
            }     
        },

        painelValoresMutation(state, valores) {
            state.valores = valores.data
        },

        AuthLoginMutation(state, tokens) {
            localStorage.setItem('access', tokens['access']);
            localStorage.setItem('refresh', tokens['refresh']);
        },

        AuthCadastroMutation(state, data) {
            state.response_cadastro = data;
        },

        CarregandoMutation(state) {
            state.carregando=!state.carregando;
        },

        getStatusParcelaMutation(state, status) {
            if(status.data[0].tipo==='entrada') {
                state.status_entrada=status.data;
            } else {
                state.status_saida=status.data;
            }
        },
    }

})

export default store;